import { useContext } from "react";
import { services } from "../data/siteContent";
import { AppContext } from "../App";

export default function ServiceDetailContent({ serviceSlug }) {
  const appContext = useContext(AppContext);
  const service = services.find((item) => item.slug === serviceSlug);

  if (!service) {
    return (
      <section className="ags-service-detail-section py-5">
        <div className="container">
          <div className="bg-light rounded-4 p-5 text-center shadow-sm">
            <p className="ags-section-kicker mb-2">Service Not Found</p>
            <h2 className="font-bold mb-3">We could not locate that service</h2>
            <p className="text-muted mb-4">
              The service you selected is unavailable. Please return to our
              services page and choose a different offering.
            </p>
            <button
              type="button"
              className="btn btn-primary btn-rounded btn-padded"
              onClick={() => appContext.navTo({ item: "services" })}
            >
              View All Services
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="ags-service-detail-section">
      <div
        className="ags-service-detail-hero"
        style={{ backgroundImage: `url(${service.image})` }}
      >
        <div className="ags-service-detail-overlay" />
        <div className="container service-header-content py-5">
          <div className="row align-items-center">
            <div className="col-lg-7 align-item-center">
              <h1 className="font-bold display-5 text-white mb-4 mt-4" data-aos="fade-right">
                {service.title}
              </h1>
              {/* <p className="text-white-75 lead mb-4">{service.description}</p>
              <div className="d-flex flex-wrap gap-2 mb-4">
                <span className="ags-glass-chip">AGS Service</span>
                <span className="ags-glass-chip">Trusted Delivery</span>
                <span className="ags-glass-chip">Ready for Projects</span>
              </div>
              <button
                type="button"
                className="btn btn-light btn-rounded btn-padded"
                onClick={() => appContext.navTo({ item: "contact" })}
              >
                Talk to our team
              </button> */}
            </div>
          </div>
        </div>
      </div>

      <div className="container pt-5 pb-5">
        <div className="row gy-5">
          <div className="col-xl-8">
            <div className="ags-service-detail-panel p-5 rounded-4 shadow-sm bg-white">
              <p className="ags-section-kicker mb-2">About this service</p>
              <h2 className="font-bold mb-4" data-aos="fade-right">
                What we deliver with this service
              </h2>
              <p className="text-muted mb-4" data-aos="fade-up">{service.description}</p>
              <div className="row g-3">
                {service.features.map((feature) => (
                  <div className="col-md-6" key={feature}>
                    <div className="ags-mini-feature">{feature}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="ags-service-detail-box bg-light rounded-4 p-4 mt-5" data-aos="fade-up">
              <h3 className="font-bold mb-3">{service.benefits.title}</h3>
              <ul className="list-unstyled mb-0">
                {service.benefits.points.map((item) => (
                  <li className="d-flex align-items-start mb-3" key={item}>
                    <span className="ags-service-detail-bullet me-3 mt-1" />
                    <span className="text-muted">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <aside className="col-xl-4">
            <div className="ags-service-detail-card p-4 rounded-4 shadow-sm bg-white" data-aos="fade-left">
              <p className="ags-section-kicker mb-2">Quick facts</p>
              <h3 className="font-bold mb-3">{service.title}</h3>
              <p className="text-muted mb-4">{service.shortDescription}</p>
              <div className="d-grid gap-3">
                <div className="ags-service-detail-feature">
                  <div className="fw-semibold">Application</div>
                  <div className="text-muted">
                    Planning, design, and operational delivery.
                  </div>
                </div>
                <div className="ags-service-detail-feature">
                  <div className="fw-semibold">Output</div>
                  <div className="text-muted">
                    Reliable maps, models, datasets, and reports.
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-primary btn-rounded btn-padded mt-2"
                  onClick={() => appContext.navTo({ item: "contact" })}
                >
                  Request a consultation
                </button>
              </div>
            </div>
          </aside>
        </div>

        <div className="ags-service-detail-related mt-5">
          <div className="row align-items-center mb-4">
            <div className="col-md-8">
              <p className="ags-section-kicker mb-2">Related services</p>
              <h2 className="section-title mb-0">
                Explore more AGS capabilities
              </h2>
            </div>
          </div>
          <div className="row g-3">
            {services
              .filter((item) => item.slug !== service.slug)
              .slice(0, 3)
              .map((item) => (
                <div className="col-md-6 col-xl-4" key={item.slug}>
                  <div
                    className="ags-related-service-card p-4 rounded-4 h-100"
                    role="button"
                    tabIndex="0"
                    onClick={() =>
                      appContext.navTo({ item: "services", subItem: item.slug })
                    }
                  >
                    <h3 className="font-bold mb-2">{item.title}</h3>
                    <p className="text-muted mb-3">{item.shortDescription}</p>
                    <span className="text-primary fw-semibold">
                      Read more →
                    </span>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}
